import React from "react";
import { Box, Typography } from "@mui/material";
import { Email, Phone, Place } from "@mui/icons-material";
import MyContainer from "../../../MyContainer";
import { useContactSectionStyles } from "./ContactSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useSharedStyles } from "../../../../styles/shared";
import ContactForm from "./contactForm/ContactForm";

const ContactSection = () => {
    const { classes } = useContactSectionStyles();
    const { classes: shared } = useSharedStyles();
    const { t } = useI18n();

    const contactItems = [
        { icon: Place, label: t("contactPage.overline"), value: t("contactPage.address"), href: undefined },
        { icon: Phone, label: t("nav.contact"), value: t("contactPage.phoneNumber"), href: `tel:${t("contactPage.phoneNumber")}` },
        { icon: Email, label: t("nav.contact"), value: t("contactPage.email"), href: `mailto:${t("contactPage.email")}` },
    ];

    return (
        <MyContainer>
            <Box className={classes.layout}>
                <Box>
                    <Typography className={`${shared.overlineLight} ${classes.overline}`}>
                        {t("contactPage.overline")}
                    </Typography>
                    <Typography variant="h2" className={classes.title}>{t("contactPage.title")}</Typography>
                    <Typography variant="body2" className={classes.description}>
                        {t("contactPage.description")}
                    </Typography>

                    <Box className={classes.contactInfo}>
                        {contactItems.map((item, i) => (
                            <Box className={classes.contactItem} key={i}>
                                <Box className={classes.contactIcon}>
                                    {React.createElement(item.icon, { fontSize: "small" })}
                                </Box>
                                <Box>
                                    <Typography className={classes.contactLabel}>{item.label}</Typography>
                                    <Typography
                                        component={item.href ? "a" : "span"}
                                        href={item.href}
                                        className={classes.contactValue}
                                    >
                                        {item.value}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <ContactForm />
            </Box>
        </MyContainer>
    );
};

export default ContactSection;
